import { render, staticRenderFns } from "./file-upload-collapsed.vue?vue&type=template&id=993e8e8c&scoped=true"
import script from "./file-upload-collapsed.vue?vue&type=script&lang=js"
export * from "./file-upload-collapsed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993e8e8c",
  null
  
)

export default component.exports